window.addEventListener("pageshow", function (evt) {
    if (evt.persisted) {
        setTimeout(function () {
            window.location.reload();
        }, 10);
    }
}, false);

// Function to wait untill the element is in the DOM
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

const searchPopdown = document.querySelector('#search-popdown');
const headerMobileSearch = document.querySelector('.header-mobile-search');
headerMobileSearch.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent default behavior
    searchPopdown.classList.toggle('is-visible');
});


const drawerUnderLays = document.querySelectorAll('.drawer__underlay');

drawerUnderLays.forEach((drawerUnderLay) => {
    drawerUnderLay.addEventListener('click', () => {
        themeVendor.BodyScrollLock.clearAllBodyScrollLocks();
        document.querySelector('body').style.overflow = '';
    })
})

const quickViewBtn = document.querySelectorAll('.product-grid-item__actions button');
if (quickViewBtn) {
    quickViewBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            waitForElm('.drawer__top.upsell__modal__top .drawer__top__left').then(elm => {
                document.querySelector('body').style.overflow = 'hidden';
                document.querySelector('.upsell__form').prepend(elm);
                if (window.innerWidth < 768) {
                    document.querySelectorAll('.upsell__modal .drawer__underlay__fill, .upsell__modal .drawer__close').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            document.querySelector('.upsell__modal').classList.remove('is-open');
                            document.querySelector('.upsell__modal').ariaHidden = true;
                            document.querySelector('body').style.overflow = 'visible';
                            document.querySelector('html').removeAttribute('data-scroll-locked');
                            themeVendor.BodyScrollLock.clearAllBodyScrollLocks();
                        });
                    });
                }
            });
        });
    });
}
const filterWrappers = document.querySelectorAll('.template-collection .sidebar__filter__group');
if (filterWrappers) {
    filterWrappers.forEach((filterWrapper) => {
        const filterButton = filterWrapper.querySelectorAll('.filter__button');
        const filterInput = filterWrapper.querySelector('.filter__button input[disabled]');
        if (filterButton && filterButton.length === 1) {
            filterWrapper.classList.add('hide');
        } else if (filterInput) {
            const button = filterInput.closest('.filter__button');
            if (button) {
                button.classList.add('hide');
            }
        }
    })
}
jQuery(function(){
    jQuery('.collection--compact-mobile').on('click', '.pagination-custom > li:not(.active):not(.disabled)', function() {
      const topDivCollection = document.querySelector(".collection--compact-mobile");
      if(topDivCollection){
          topDivCollection.scrollIntoView({block: "start", behavior: "smooth"});
      }
    });     
});